var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.014 2.764a2.453 2.453 0 001.396-.578 2.453 2.453 0 013.18 0c.393.335.882.537 1.397.578a2.453 2.453 0 012.25 2.25 2.45 2.45 0 00.578 1.396 2.452 2.452 0 010 3.18 2.453 2.453 0 00-.579 1.397 2.452 2.452 0 01-2.25 2.25 2.453 2.453 0 00-1.395.578 2.452 2.452 0 01-3.181 0 2.453 2.453 0 00-1.396-.579 2.452 2.452 0 01-2.25-2.25 2.453 2.453 0 00-.578-1.395 2.453 2.453 0 010-3.181c.335-.393.537-.882.578-1.396a2.453 2.453 0 012.25-2.25zm5.952 4.202a.8.8 0 00-1.131-1.131L7.2 8.469 6.166 7.435a.8.8 0 00-1.131 1.13l1.6 1.6a.8.8 0 001.13 0l3.2-3.2z",
    fill: "currentColor"
  })));
}
export default SvgBadgeSuccess;